module.exports = __webpack_public_path__ + "static/img/country-us.17a0f02966.svg";